import React, { useState } from "react";
import Error from "components/form/Error";
import InputAreaPrice from "components/form/InputAreaPrice";
import LabelArea from "components/form/LabelArea";
import StartTimePicker from "components/form/StartTimePicker";
import EndTimePicker from "components/form/EndTimePicker";
import SelectMultipleVehicleCategoryAirport from "components/form/SelectMultipleVehicleCategoryAirport";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

const DynamicAirportPeriodicHikeTimeInput = ({
  StartTimeOptions,
  setDataInput,
  dataInput,
  register,
  errors,
  handleVehicleCategoryChange,
  handleChange,
  handleEndTimeChange,
  handleStartTimeChange,
}) => {
  const handleClick = () => {
    setDataInput((prevData) => [
      ...prevData,
      {
        [`start_time_${prevData.length}`]: "12:00 AM",
        [`end_time_${prevData.length}`]: "12:30 AM",
        ["vehicle_type_" + prevData.length]: [],
        ["hike_" + prevData.length]: "",
        ["endTimeOptions_" + prevData.length]: StartTimeOptions.slice(1),
      },
    ]);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const handleDelete = (i) => {
    setDataInput((prevData) => {
      const newData = prevData.filter((_, index) => index !== i);

      const endTimeOptions = [
        "12:30 AM",
        "1:00 AM",
        "1:30 AM",
        "2:00 AM",
        "2:30 AM",
        "3:00 AM",
        "3:30 AM",
        "4:00 AM",
        "4:30 AM",
        "5:00 AM",
        "5:30 AM",
        "6:00 AM",
        "6:30 AM",
        "7:00 AM",
        "7:30 AM",
        "8:00 AM",
        "8:30 AM",
        "9:00 AM",
        "9:30 AM",
        "10:00 AM",
        "10:30 AM",
        "11:00 AM",
        "11:30 AM",
        "12:00 PM",
        "12:30 PM",
        "1:00 PM",
        "1:30 PM",
        "2:00 PM",
        "2:30 PM",
        "3:00 PM",
        "3:30 PM",
        "4:00 PM",
        "4:30 PM",
        "5:00 PM",
        "5:30 PM",
        "6:00 PM",
        "6:30 PM",
        "7:00 PM",
        "7:30 PM",
        "8:00 PM",
        "8:30 PM",
        "9:00 PM",
        "9:30 PM",
        "10:00 PM",
        "10:30 PM",
        "11:00 PM",
        "11:30 PM",
      ];

      const reIndexedData = newData.map((item, index) => {
        return {
          [`start_time_${index}`]:
            item[
              Object.keys(item).find((key) => key.startsWith("start_time"))
            ] || "",
          [`end_time_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("end_time"))] ||
            "",
          [`vehicle_type_${index}`]:
            item[
              Object.keys(item).find((key) => key.startsWith("vehicle_type"))
            ] || "",
          [`hike_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("hike"))] || "",
          [`endTimeOptions_${index}`]: endTimeOptions,
        };
      });

      return reIndexedData;
    });
  };

  const handleDeleteConfirm = () => {
    handleDelete(deleteIndex);
    setShowDeleteModal(false);
  };
  return (
    <div className="col-span-full relative">
      <div className="grid grid-cols-7 gap-5 col-span-8">
        <div className="block">
          <LabelArea label={"Start Time"} />
        </div>
        <div>
          <LabelArea label={"End Time"} />
        </div>
        <div className="col-span-2">
          <LabelArea label={"Vehicle Type"} />
        </div>
        <div>
          <LabelArea label={"Hike"} />
        </div>
      </div>
      {dataInput.map((val, i) => (
        <div className="grid grid-cols-7 gap-5 mb-8 col-span-8" key={i}>
          {Object.keys(val).map((key) => (
            <React.Fragment key={key}>
              {key.startsWith("start_time_") && (
                <div className="" key={key}>
                  <StartTimePicker
                    register={register}
                    name={key}
                    label="Start Time"
                    type="text"
                    StartTimeOptions={StartTimeOptions}
                    selectedStartTime={val[key]}
                    handleStartTimeChange={(e) =>
                      handleStartTimeChange(
                        e,
                        parseInt(key.substring("start_time_".length)),
                        i
                      )
                    }
                    placeholder={"Start Time"}
                  />
                  <Error errorName={errors[key]} />
                </div>
              )}
              {key.startsWith("end_time_") && (
                <div className="">
                  <EndTimePicker
                    register={register}
                    name={key}
                    label="End Time"
                    type="text"
                    EndTimeOptions={
                      val[
                        `endTimeOptions_${parseInt(
                          key.substring("end_time_".length)
                        )}`
                      ]
                    }
                    selectedEndTime={val[key]}
                    handleEndTimeChange={(e) =>
                      handleEndTimeChange(
                        e,
                        parseInt(key.substring("end_time_".length)),
                        i
                      )
                    }
                    placeholder={"Time"}
                  />
                  <Error errorName={errors[key]} />
                </div>
              )}
              {key.startsWith("vehicle_type_") && (
                <div className="col-span-2">
                  <SelectMultipleVehicleCategoryAirport
                    register={register}
                    label="Vehicle Type"
                    name={key}
                    selectedVehicle={val[key]}
                    handleVehicleChange={(selected) =>
                      handleVehicleCategoryChange(
                        selected,
                        parseInt(key.substring("vehicle_type_".length)),
                        key
                      )
                    }
                    type="text"
                    placeholder={"--Choose--"}
                  />
                  <Error errorName={errors[key]} />
                </div>
              )}
              {key.startsWith("hike_") && (
                <div className="grid-cols-1">
                  <InputAreaPrice
                    register={register}
                    name={key}
                    label="Hike"
                    type="text"
                    maxLength={2}
                    required={true}
                    value={val[key]}
                    onChangeFunction={(e) =>
                      handleChange(e, parseInt(key.substring("hike_".length)))
                    }
                    placeholder={"Hike in %"}
                  />
                  <Error errorName={errors[key]} />
                </div>
              )}
              {key.startsWith("hike_") && (
                <div className="flex items-center">
                  {Object.keys(dataInput).length !== 1 && (
                    <button
                      style={{ top: "1rem", outline: "none", color: "grey" }}
                      className="ml-8 outline-none"
                      type="button"
                      aria-label="Remove item"
                      onClick={() => {
                        setDeleteIndex(i);
                        setShowDeleteModal(true);
                      }}
                    >
                      X
                    </button>
                  )}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      ))}

      <div className="mt-6 lg:mt-1">
        <button
          style={{
            bottom: "-15px",
            color: "#0e9f6e",
            fontSize: "42px",
            outline: "none",
          }}
          className="absolute right-0 outline-none"
          type="button"
          onClick={handleClick}
        >
          +
        </button>
      </div>
      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};

export default DynamicAirportPeriodicHikeTimeInput;
